<template>
  <a-modal
    v-model="visible"
    :title="`${formIsEdit ? `Edit Customer` : 'Add New Customer'} `"
    :maskClosable="false"
    :closable="!formLoading"
    :okText="$t('com_btn_save')"
    :width="700"
    @ok="formSubmit"
    @cancel="formReset"
    :confirmLoading="formLoading"
    :cancelButtonProps="{
      props: {
        disabled: formLoading,
      },
    }"
    destroyOnClose
    style="max-height:90vh !important;"
    centered
  >
    <Loading v-if="loading" :show="true" />
    <a-form-model
      :model="form"
      :rules="formRules"
      ref="formElement"
      :label-col="{ span: 7 }"
      :wrapper-col="{ span: 14 }"
      v-else
    >
      <!-- 客户名称 -->
      <a-form-model-item :label="$t('customer_form_name')" prop="name">
        <a-input
          v-model="form.name"
          :placeholder="$t('customer_form_name_placeholder')"
          allowClear
          @input="formInput"
          ref="formName"
        />
      </a-form-model-item>

      <!-- 客户代码  -->
      <a-form-model-item :label="$t('customer_form_code')" prop="code">
        <a-input
          v-model="form.code"
          :placeholder="$t('customer_form_code_placeholder')"
          allowClear
          @input="formInput"
        />
      </a-form-model-item>

      <!-- 所属区域 -->
      <a-form-model-item :label="$t('com_form_area')" prop="areaId">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          v-model="form.areaId"
          show-search
          allowClear
          :placeholder="$t('com_form_area_select')"
          style="width:100%"
          :filter-option="filterOption"
          @change="areaChange()"
        >
          <a-select-option :value="area.id" v-for="area in areaList" :key="area.id">
            {{ area.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('com_form_region')" prop="regionId">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          v-model="form.regionId"
          show-search
          allowClear
          :placeholder="$t('com_form_region_select')"
          style="width:100%"
          :filter-option="filterOption"
        >
          <a-select-option :value="country.id" v-for="country in countryList" :key="country.id">
            {{ country.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 客户logo -->
      <a-form-model-item :label="$t('customer_form_logo')" prop="icons">
        <UploadOSS
          :value="form.icons"
          :manuallyUpload="false"
          @change="
            fileList => {
              form.icons = fileList || [];
            }
          "
          :maxCount="1"
          ref="uploadFile"
          uploadDirInOSS="images"
          uploadType="image"
        />
      </a-form-model-item>

      <!-- 联系人  -->
      <a-form-model-item :label="$t('com_form_contact_person')" prop="contactPerson">
        <a-input
          v-model="form.contactPerson"
          :placeholder="$t('com_form_contact_person_placeholder')"
          allowClear
          @input="formInput"
        />
      </a-form-model-item>

      <!-- 联系电话  -->
      <a-form-model-item :label="$t('com_form_telephone')" prop="contact">
        <a-input
          v-model="form.contact"
          :placeholder="$t('com_form_telephone_placeholder')"
          allowClear
          @input="formInput"
        />
      </a-form-model-item>

      <!-- 联系地址  -->
      <a-form-model-item :label="$t('com_form_address')" prop="address">
        <a-textarea
          v-model="form.address"
          :rows="3"
          :placeholder="$t('com_form_address_placeholder')"
          allowClear
          @input="formInput"
        />
      </a-form-model-item>
    </a-form-model>
    <!-- 错误描述 -->
    <div class="form-error-text">
      <Icon type="error" v-if="formError" />
      <p>{{ formError }}</p>
    </div>
  </a-modal>
</template>
<script>
import * as API from '@/api/system/customer';
import areaMixin from '@/mixins/area';

export default {
  mixins: [areaMixin],
  props: {
    callback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      customerId: null,
      customerInfo: null,
      // 新增
      visible: false,
      loading: true,
      formRules: {
        name: [
          {
            required: true,
            message: this.$t('customer_form_name_placeholder'),
            trigger: 'change',
          },
        ],
        code: [
          {
            required: true,
            message: this.$t('customer_form_code_placeholder'),
            trigger: 'change',
          },
        ],
        regionId: [
          {
            required: true,
            message: this.$t('com_form_region_select'),
            trigger: 'change',
          },
        ],
        areaId: [
          {
            required: true,
            message: this.$t('com_form_area_select'),
            trigger: 'change',
          },
        ],
      },

      // 搜索
      form: {
        name: undefined,
        code: undefined,
        areaId: undefined,
        regionId: undefined,
        icons: undefined,
        contactPerson: undefined,
        contact: undefined,
        address: undefined,
      },

      formError: '',
      formIsEdit: false,
      formLoading: false,
    };
  },
  methods: {
    // 获取表单数据
    getData() {
      this.loading = true;
      const _list = [this.getAreaList()];

      // 编辑
      if (this.formIsEdit) {
        _list.push(this.getCustomerDetail());
      }
      Promise.all(_list).finally(() => {
        // 更新area/region
        this.getCountryList(this.form.areaId);

        this.loading = false;

        // focus name
        this.$nextTick(() => {
          this.$refs.formName && this.$refs.formName.focus();
        });
      });
    },

    getCustomerDetail() {
      return API.CustomerDetail({
        customerId: this.customerId,
      }).then(res => {
        if (res.code === 0) {
          this.customerInfo = res.data.customerInfo;
          if (res.data) {
            Object.keys(this.form).forEach(key => {
              if (key === 'isRootable') {
                this.form[key] = !!this.customerInfo['root'];
              } else {
                this.form[key] = this.customerInfo[key];
              }
            });
          }
        }
      });
    },

    // 父模型过滤
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    // 显示
    show(customerId) {
      this.visible = true;
      this.formIsEdit = customerId ? true : false;
      this.customerId = customerId;

      this.getData();
    },

    // 提交
    formSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          this.formLoading = true;

          const params = { ...this.form };

          // 指定字段，格式化两边的空格
          for (const key in params) {
            if (['isRootable', 'isReadable'].includes(key)) {
              params[key] = !!this.form[key];
            }
          }

          if (this.formIsEdit) {
            params.customerId = this.customerInfo.customerId;
            // 编辑
            API.CustomerEdit(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_edit_success'));
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formError = res.message;
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          } else {
            // 添加
            API.CustomerAdd(params)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_add_success'));
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formError = res.message;
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    updateList() {
      this.callback && this.callback();
    },

    // error reset
    formInput() {
      this.formError = '';
    },

    // add form reset
    formReset() {
      this.$refs.formElement.resetFields();
      Object.keys(this.form).forEach(key => {
        if (['isRootable', 'isReadable'].includes(key)) {
          this.form[key] = false;
        } else {
          this.form[key] = undefined;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;
  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}

::v-deep .ant-form-item {
  margin-bottom: 10px;
}
</style>
